export enum HsaIntentSource {
  BuyButton = "buy_button",
  LmnStarted = "lmn_started",
  LmnCompleted = "lmn_completed",
  PdpWidget = "pdp_widget",
  CartWidget = "cart_widget",
}
